import Vue from 'vue'
import VueRouter from 'vue-router'

// Import your views/pages
import BlogHomePage from '../views/BlogHomePage.vue'
import BookListPage from '../views/BookListPage.vue'
import BookDetailPage from '../views/BookDetailPage.vue'
import BlogAllBooksPage from '../views/BlogAllBooksPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: BlogHomePage
  },
  {
    path: '/books',
    name: 'BookList',
    component: BookListPage
  },
  {
    path: '/book/:id',
    name: 'BookDetail',
    component: BookDetailPage,
    props: true
  },
  {
    path: '/allBooks',
    name: 'BlogAllBooksPage',
    component: BlogAllBooksPage,
    props: true
  },
  // Optional: Add a catch-all route
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history', // Uses HTML5 history mode
  base: process.env.BASE_URL,
  routes
})

export default router